function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSlope = function SvgSlope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "slope_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 51.983,
    y1: 7.072,
    x2: 51.983,
    y2: 76.127,
    gradientTransform: "scale(.21875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a8adff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "slope_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 76.018,
    y1: 51.958,
    x2: 76.018,
    y2: 120.928,
    gradientTransform: "scale(.21875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    style: {
      stopColor: "#b6baff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4e2ff",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#6e66fa",
      fillOpacity: 1
    },
    d: "M14 0c7.73 0 14 6.27 14 14s-6.27 14-14 14S0 21.73 0 14 6.27 0 14 0Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#slope_svg__a)"
    },
    d: "m6.113 11.41 5.258-5.273 4.512-4.461a.438.438 0 0 1 .746.308v9.426l-5.258 5.242Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#slope_svg__b)"
    },
    d: "m21.887 16.625-5.258-5.258-5.258 5.258v9.39c0 .387.469.583.746.31Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f1f0ff",
      fillOpacity: 1
    },
    d: "M6.113 11.41h3.66c.883 0 1.598.715 1.598 1.598v3.644h-3.66a1.597 1.597 0 0 1-1.598-1.597ZM16.629 11.41h3.66c.883 0 1.598.715 1.598 1.598v3.644h-3.66a1.597 1.597 0 0 1-1.598-1.597Zm0 0"
  }));
};
export default SvgSlope;